export const GLOBAL = 'SourceEmbeds'
export const PAGE_QUERY_UNLOCK_KEY = 'StgbEE5LEe6j2Uu38haiJw'
export const DEFAULT_PAGE_QUERY_PARAM_PREFIX = '^_sdembed_'
export const DEFAULT_EMBED_SCRIPT_VERSION = '1'
export const DEFAULT_EMBED_SCRIPT_URL = 'https://cdn.sourcesync.io/embed/'
export const DEFAULT_EMBED_SCRIPT_NAME = 'embed.min.js'
export const DEFAULT_LOCAL_STORAGE_KEY = 'source-embeds-settings'
